

export enum ExportTypes {
    GET_EXPORT = '@@file/GET_EXPORT',
    GET_EXPORT_SUCCESS = '@@file/GET_EXPORT_SUCCESS',
    GET_EXPORT_ERROR = '@@file/GET_EXPORT_ERROR',
    CLEAN_FILE = '@@file/CLEAN_FILE',
    SET_EXPORT_FILE = '@@file/SET_EXPORT_FILE',

    GET_EXPORT_DASHBOARD_PDF = '@@file/GET_EXPORT_DASHBOARD_PDF',
    GET_EXPORT_DASHBOARD_XLS = '@@file/GET_EXPORT_DASHBOARD_XLS',
    GET_EXPORT_PLAYER_PDF = '@@file/GET_EXPORT_PLAYER_PDF',
    GET_EXPORT_PLAYER_XLS = '@@file/GET_EXPORT_PLAYER_XLS',
    GET_EXPORT_STATS_EVOLUTION_PDF = '@@file/GET_EXPORT_STATS_EVOLUTION_PDF',
    GET_EXPORT_STATS_EVOLUTION_XLS = '@@file/GET_EXPORT_STATS_EVOLUTION_XLS',
    GET_EXPORT_DASHBOARD_DETAILS_PDF = '@@file/GET_EXPORT_DASHBOARD_DETAILS_PDF',
    GET_EXPORT_DASHBOARD_DETAILS_XLS = '@@file/GET_EXPORT_DASHBOARD_DETAILS_XLS',
}
export type IExportType = 'csv' | 'xml' | 'dip4' | 'xls' | 'pdf'
export const maxFilesDownload:number = 20000 

export interface GetExportPayload {
    filters: any;
    exportType: IExportType;
    page: string;
} 

export interface IExportFilters {
    media_ids: number[],
    program_type_ids: number[],
    program_editor_ids: number[],
    time_slot_start: string,
    time_slot_end: string,
    date_type: string,
    date_start: Date,
    date_end: Date,
    display: string,
    show_detail_list: number[],
    show_detail?:boolean
    program_name?: string
}

export interface IExportState {
    
    readonly filters: IExportFilters | null;
    readonly file: any;
    readonly user_id: number | null;
    readonly file_name: string | null;
}